// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2vkTD","unreadBadge":"styles_unreadBadge__1AvJh","modalContent":"styles_modalContent__2Mr1y","modal":"styles_modal__3Ug4N"};